import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Chevron } from "@speedoc/design-assets/build/icons/index";

const FAQs = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [accordionIndex, setAccordionIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggle = index => {
    if (accordionIndex === index) {
      toggleCurrentAccordion(index);
    } else {
      toggleCurrentAccordion(index);
      setAccordionIndex(index);
      setIsExpanded(isExpanded);
    }
  };

  const toggleCurrentAccordion = index => {
    setAccordionIndex(index);
    setIsExpanded(!isExpanded);
  };

  const buildAccordionList = (columnIndex, columnClassName) => {
    return (
      <div className={columnClassName}>
        {content.faqItems.map(
          (faq, index) =>
            ((columnIndex === 1 && index % 2 === 0) || (columnIndex === 2 && index % 2 === 1) || columnIndex === 0) && (
              <div key={`faq_${index}`} className="accordion">
                <div
                  className={`accordion-title ${isExpanded && accordionIndex === index ? "expanded" : ""}`}
                  onClick={() => toggle(index)}>
                  <div className="chevron-icon">
                    <Chevron />
                  </div>

                  <h6>{faq.title}</h6>
                </div>
                <p
                  className={`accordion-content ${isExpanded && accordionIndex === index ? "" : "collapsed"}`}
                  dangerouslySetInnerHTML={{ __html: faq.content }}
                />
              </div>
            )
        )}
      </div>
    );
  };
  const headerText = isMobile ? content.headermobile : content.header;
  return (
    <div id="FAQs">
      <div className="wrap">
        <div className="subHeader">{content.subheader}</div>
        <div className="header">{headerText}</div>
        <div className="faqContainer">
          {isMobile ? (
            buildAccordionList(0, "columnOne")
          ) : (
            <>
              {buildAccordionList(1, "columnOne")}
              {buildAccordionList(2, "columnTwo")}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQs;
